export default {
    // EntityTypeSelector - Entity type labels
    entityUnitDriverSelector_drivers: "Conductores",
    entityUnitDriverSelector_units: "Unidades",

    // ContentArea - "All" option selected messages
    entityUnitDriverSelector_allDriverSelected: "Todos los conductores están seleccionados",
    entityUnitDriverSelector_allUnitSelected: "Todas las unidades están seleccionadas",

    // OptionSelector - Option labels for all/entities/tags
    entityUnitDriverSelector_allDriver: "Todas los Conductores",
    entityUnitDriverSelector_allUnit: "Todas las Unidades",
    entityUnitDriverSelector_singleDriver: "Por Conductores",
    entityUnitDriverSelector_singleUnit: "Por Unidad",
    entityUnitDriverSelector_tags: "Etiquetas",

    // InactiveDriversToggle - Toggle options and label
    entityUnitDriverSelector_includeInactiveDrivers: "Incluir conductores inactivos",
    entityUnitDriverSelector_notOption: "No",
    entityUnitDriverSelector_yesOption: "Si",

    // EntityTagPickerSingle - Search, inactive label, no items
    entityTagPicker_inactive: "Inactivo",
    entityTagPicker_noItemsFound: "No se encontraron elementos",
    entityTagPicker_search_driver: "Seleccionar conductores o buscar por nombre",
    entityTagPicker_search_unit: "Seleccionar unidades o buscar por nombre",
};
